/* eslint-disable eqeqeq */
/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState } from 'react'
import {
  Header,
  Footer,
  Service_Link_Box,
  Loading,
} from '../../components/index'
import { Col, Row } from 'react-bootstrap'
import { WebApi } from '../../api/web'
import { Url } from '../../services/url'
const Service = () => {
  const [services, setServices] = useState(null)
  useEffect(() => {
    getService()
  }, [])
  const getService = async () => {
    await WebApi.services()
      .then((res) => {
        setServices(res.data.data.services)
      })
      .catch((err) => {})
  }

  return (
    <>
      <Header title='خدمات دکتر وکیل' />
      <div className='container'>
        <div className='template-pages'>
          <Row>
            {services ? (
              services.map((service) => (
                <Col xs={6} md={4} className='px-xs-5'>
                  <Service_Link_Box
                    icon={<img src={`${Url}/${service.icon}`} alt='icon' />}
                    title={service.title}
                    slug={service.slug}
                  />
                </Col>
              ))
            ) : (
              <Loading />
            )}
          </Row>
        </div>
      </div>
      <Footer />
    </>
  )
}
export default Service
